import { render, staticRenderFns } from "./Scatterplot.vue?vue&type=template&id=3adaf7fb"
import script from "./Scatterplot.vue?vue&type=script&lang=js"
export * from "./Scatterplot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports